import styled from 'styled-components';

interface ModalContainerProps {
  isModalOpen: boolean;
}

export const ButtonAndModalWrapper = styled.div`
  position: relative;
`;

export const DatePickerButton = styled.div`
  display: flex;
  align-items: center;
  background: #4a90e2;
  box-shadow: 0px 4px 8px rgba(0, 34, 102, 0.1);
  border-radius: 6px;
  padding: 15px 15px;
  border: 0;
  height: 46px;
  width: 100%;

  &:hover {
    cursor: pointer;
  }

  span {
    font-weight: 500;
    font-size: 12px;
    line-height: 13px;
    color: #ffffff;
  }
`;

export const LayerTouchable = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 99vw;
  height: 120vh;
`;

export const ModalContainer = styled.div<ModalContainerProps>`
  position: absolute;
  top: 56px;
  left: 0;
  cursor: default;

  background: #ffffff;
  border: 1px solid #e4e9f0;
  box-sizing: border-box;
  box-shadow: 0px 4px 8px rgba(0, 34, 102, 0.25);
  border-radius: 10px;

  padding: 0 50px 50px 50px;

  z-index: ${({ isModalOpen }) => (isModalOpen ? 50 : 10)};

  .calendar-button {
    border: none;

    .leftArrow {
      position: absolute;
      top: calc(50% - 14px);
      left: -25px;
      z-index: 50;
      width: 28px;
      cursor: pointer;
    }

    .rightArrow {
      position: absolute;
      top: calc(50% - 14px);
      right: -25px;
      z-index: 50;
      width: 28px;
      cursor: pointer;
    }
  }

  .DayPicker {
    width: 100%;
  }

  .DayPicker-wrapper {
    width: 100%;
    position: relative;
  }

  .DayPicker-Months {
    flex-wrap: initial;
  }

  .DayPicker-Caption {
    text-align: center;
    div {
      font-weight: 300;
      font-size: 16px;
      line-height: 24px;

      letter-spacing: 0.12px;

      color: #475466;
    }
  }

  .DayPicker-Weekday {
    abbr {
      font-weight: 700;
      font-size: 10px;
      line-height: 16px;
      letter-spacing: 1.5px;
      text-transform: uppercase;
      color: #475466;
    }
  }

  .DayPicker-Day {
    border-radius: 0;
  }

  .DayPicker-Day + .DayPicker-Day--selected:not(.DayPicker-Day--outside) {
    background-color: #4a90e2;
  }

  .DayPicker-Day--start:not(.DayPicker-Day--outside) {
    background-color: #164194 !important;
    border-top-left-radius: 60% !important;
    border-bottom-left-radius: 60% !important;
  }

  .DayPicker-Day--end:not(.DayPicker-Day--outside) {
    border-top-right-radius: 50% !important;
    border-bottom-right-radius: 50% !important;
    background-color: #164194 !important;
  }

  .DayPicker-Week {
    border-bottom: 3px solid #ffffff;
  }

  .DayPicker-Week :last-child {
    border-top-right-radius: 50% !important;
    border-bottom-right-radius: 50% !important;
  }

  .DayPicker-Week :first-child {
    border-top-left-radius: 50% !important;
    border-bottom-left-radius: 50% !important;
  }
`;

export const ModalFooter = styled.div`
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  
  button.select-semestre {
    cursor: pointer;
    font-size: 12px;
    line-height: 24px;
    letter-spacing: 0.12px;
    text-decoration-line: underline;
    font-weight: 300;
    color: #4a90e2;
    border: none;
    background-color: transparent;
  }
  
`;
